import { get, patch, post } from "../helpers/config";
import { useMutation, UseMutationOptions } from '@tanstack/react-query';
import { IAgentVehicleRequest } from "../types/attendant";

export const useCompleteAgentProfile = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("agent/complete-profile", data);
    }, options);
};

export const useUpdateAgentStatus = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("agent/status/update?agentId=" + data.agentId + "&statusCode=" + data.statusCode + "&reason=" + data.reason, data);
    }, options);
};

export const useDeleteAgentPermanently = (options: any) => {
    return useMutation(async (agentId:string) => {
        return await patch(`agent/${agentId}/delete`, {});
    }, options);
};

export const useGetDocumentTypes = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("agent/documenttypes");
    }, options);
};

export const useAddAgentDocument = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await post("agent/document", data);
    }, options);
};

export const useApproveRejectAgent = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        return await patch("agent/approve-reject", data);
    }, options);
};


export const useFetchAgentList = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: any) => {
        let url = `agent/list?statusId=${data.statusId}&pageNumber=${data.pageNumber}&pageSize=${data.pageSize}&searchFilter=${data.searchFilter}`;
        if (data.countryId) {
            url += `&countryId=${data.countryId}`;
        }
        return await get(url);
    }, options);
};

export const useFetchAgentStatuses = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async () => {
        return await get("agent/statuses");
    }, options);
};

export const useFetchAgentProfileInfo = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (agentId: string) => {
        return await get(`agent/profile-info?agentId=${agentId}`);
    }, options);
};

export const useFetchAgentSchedules = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (agentId: string) => {
        return await get(`agent/get-schedules?agentId=${agentId}`);
    }, options);
};

export const useAdminUpdateAgentSchedule = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: { agentId: string; payload: any }) => {
        return await patch(`agent/admin/schedules?agentId=${data.agentId}`, data.payload);
    }, options);
};

export const useUpdateAgentAvailability = (options?: UseMutationOptions<any, any, any, any>) => {
    return useMutation(async (data: { agentId: string; statusId: number; fromDateTime: string; toDateTime: string }) => {
        return await post("agent/update-availability", {
            agentId: data.agentId,
            statusId: data.statusId,
            fromDateTime: data.fromDateTime,
            toDateTime: data.toDateTime,
        });
    }, options);
};

export const useResetAgentSchedules = (options?: UseMutationOptions<any, any, any, any>) => {
  return useMutation(async () => {
    return await patch("agent/reset-schedule",{});
  }, options);
};

export const useUpdateAgentVehicle = (options?: UseMutationOptions<any,any,any, any>) => {
return useMutation( async (data:IAgentVehicleRequest) => {
    return await post("vehicle/add", data);  
}, options);
}

export const useFetchAgentVehicleDetails = (options?: UseMutationOptions<any, any, any, any>) => {
  return useMutation(async (agentId: string) => {
    return await get(`vehicle/get?agentID=${agentId}`);
  }, options);
}

export const useFetchVehicleTypes = (options?: UseMutationOptions<any, any, any, any>) => {
  return useMutation(async () => {
    return await get("vehicle/get-vehicle-types");
  }, options);
}


